import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchEvaluation = (
  evaluationId: string,
  setEvaluation: Function,
  setLoaded: Function,
  language: string
) => {
  ApiService.get(`evaluations/${evaluationId}?get_evaluation_details=true`)
    .then((response) => {
      setEvaluation(response.data.evaluation);
    })
    .catch((err) => {
      console.error("Error while loading evaluation:", err);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setLoaded(true));
};

export const handleCopy = async (text: string, onSuccess: Function) => {
  try {
    await navigator.clipboard.writeText(text);
    onSuccess();
  } catch (err) {
    console.error("Copy error:", err);
  }
};

export const fetchEvaluationModules = (
  evaluationId: number,
  setEvaluationModules: Function,
  setLoaded: Function,
  language: string
) => {
  ApiService.get(`evaluations/${evaluationId}/modules`)
    .then((response) => {
      setEvaluationModules(response.data.evaluation_modules);
    })
    .catch((error) => {
      console.error("Error while loading evaluation modules:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setLoaded(true));
};

export const navigateToEvaluationFilePreSignedUrl = (evaluation_id: number, language: string) => {
  ApiService.get(`evaluations/${evaluation_id}/file/link`)
    .then((response) => {
      const link = response.data.evaluation_file_link;

      if (link === "") {
        alert(translate(language, "PAGES.EVALUATION.ERROR_LOADING"));
      } else {
        window.open(link, "_blank");
      }
    })
    .catch((err) => {
      console.error("An error occurred during evaluation file pre-signed url generation", err);
      alert(translate(language, "ERROR.API_ERROR"));
    });
};
